
import { Vue, Component } from "vue-property-decorator";
import { SmartSVG, SVGLibraryCustom } from "_components";
@Component({
  name: "HomeWhatsComingButtons",
  components: { SmartSVG },
})
export default class HomeWhatsComingButtons extends Vue {
  rootClass = "c-home-whats-coming-buttons";
  icon = SVGLibraryCustom.PQArrowRightBreadcrumbs;
  SVGLibraryCustom = SVGLibraryCustom;
}
